/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import {
  CardIcon,
  Club,
  Heart,
  Diamond,
  Spade,
  HandIndicator,
} from "../../utils/Icons";
import "./gametable.css";
import { Card, GameTableProps } from "../../GameTypes/game.type";

// import youWon from "../assets/images/youWon.webp";
// import INR from "../assets/images/INR.webp";
// import star from "../assets/images/stars.png";

import youWon from "../../assets/images/youWon.webp";
import INR from "../../assets/images/INR.webp";
import star from "../../assets/images/stars.png";

import CustomModal from "../CustomModal/CustomModal";
import useCounterStore from "../../store/store";
import { setLocalItem } from "../../utils/helpers";
import winSound from "../../assets/sounds/win.mp3";
import loseSound from "../../assets/sounds/lose.mp3";



const GameTable: React.FC<GameTableProps> = ({
  handStatuses,
  playerSplitTotal,
  setCardSize,
  cardSize,
  setDealerHandRef,
  setPlayerHandRef,
  playerCards,
  dealerCards,
  flippedCards,
  playerTotal,
  dealerTotal,
  dealerSecondCardRevealed,
  gameStatus,
  isSplit,
  handIndex,
  setPlayerSplitHandRef,
  hasPlayerStand,
}) => {
  const {
    isMovieMode,
    setWalletAmt,
    walletAmt,
    betAmt,
    setBetAmt,
    isSound,
    winningAmt,
    setWinningAmt,
    liveWageredStatusAction,
    updateWinLoseCountAction,
  } = useCounterStore((state) => state);

  const [delayedPlayerTotal, setDelayedPlayerTotal] = useState(playerTotal);
  const [delayedPlayerSplitTotal, setDelayedPlayerSplitTotal] = useState(0);
  const [delayedDealerTotal, setDelayedDealerTotal] = useState(dealerTotal);

  const [openModal, setOpenModal] = useState<boolean>(false);

  useEffect(() => {
    const playerTimeout = setTimeout(
      () => setDelayedPlayerTotal(playerTotal),
      500
    );
    return () => clearTimeout(playerTimeout);
  }, [playerTotal]);

  useEffect(() => {
    const playerSplitTimeout = setTimeout(
      () => setDelayedPlayerSplitTotal(playerSplitTotal),
      500
    );
    return () => clearTimeout(playerSplitTimeout);
  }, [playerSplitTotal]);

  useEffect(() => {
    const dealerTimeout = setTimeout(
      () => setDelayedDealerTotal(dealerTotal),
      500
    );
    return () => clearTimeout(dealerTimeout);
  }, [dealerTotal]);

  // const [cardSize, setUpdatedCardSize] = useState({
  //   width: 96,
  //   height: 144,
  //   gap: 13,
  //   margin: 0,
  // });

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1067) {
        setCardSize({ width: 64, height: 96, gap: 8, margin: 22 });
      } else {
        setCardSize({ width: 96, height: 144, gap: 13, margin: 0 });
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (setCardSize) {
      setCardSize(cardSize);
    }
  }, [cardSize, setCardSize]);

  const renderCard = (card: Card, index: number, totalCards: number) => {
    let Icon =
      card.suit === "hearts"
        ? Heart
        : card.suit === "diamonds"
        ? Diamond
        : card.suit === "clubs"
        ? Club
        : Spade;
    const isFlipped = flippedCards.includes(Number(card.id));
    const isDealerSecondCard = index === 1 && dealerSecondCardRevealed;

    const shouldAddMargin = isSplit
      ? totalCards > 4
      : window.innerWidth < 1067 && totalCards > 4;

    return (
      <div
        className={`card-container ${
          isFlipped && !isDealerSecondCard ? "card-flipped" : ""
        }`}
        key={card.id}
        style={shouldAddMargin ? { marginLeft: "-22px" } : {}}
      >
        <div className="blackjack-card card-front">
          <span
            className={
              card.suit === "hearts" || card.suit === "diamonds"
                ? "red-card"
                : ""
            }
          >
            {card.value}
          </span>
          <Icon />
        </div>
        <div className="blackjack-card card-back">
          <div className="card-bg">
            <CardIcon />
          </div>
        </div>
      </div>
    );
  };

  const calculateContainerWidth = (cardCount: number) => {
    if (cardCount === 0) return "auto";

    let baseWidth = cardCount * cardSize.width + (cardCount - 1) * cardSize.gap;
    let marginReduction =
      window.innerWidth < 1067 && cardCount > 4
        ? (cardCount - 1) * cardSize.margin
        : 0;

    return `${baseWidth - marginReduction}px`;
  };

  const playerContainerStyles = {
    width: calculateContainerWidth(playerCards[0].length),
    height: isSplit ? `${cardSize.height / 1.5}px` : `${cardSize.height}px`,
    columnGap: `${cardSize.gap}px`,
  };

  const playerSplitContainerStyles = {
    width: calculateContainerWidth(playerCards[1].length),
    height: isSplit ? `${cardSize.height / 1.5}px` : `${cardSize.height}px`,
    columnGap: `${cardSize.gap}px`,
  };

  const dealerContainerStyles = {
    width: calculateContainerWidth(dealerCards.length),
    height: `${cardSize.height}px`,
    columnGap: `${cardSize.gap}px`,
  };

  const playerBoxClass =
    gameStatus === "player won"
      ? "winner"
      : gameStatus === "dealer won"
      ? "loose"
      : gameStatus === "dealer lost"
      ? "winner"
      : gameStatus === "player lost"
      ? "loose"
      : gameStatus === "draw"
      ? "draw"
      : "";

       

  useEffect(() => {
    if (playerBoxClass === "winner") {
      let amt = betAmt * 1.92;
      setWinningAmt(amt);
      setWalletAmt(walletAmt + amt);
      setLocalItem("depositAmt", walletAmt + amt);

      liveWageredStatusAction("profit", amt);
      updateWinLoseCountAction("win");

    if(isSound){
      const win = new Audio(winSound);
      win.play();
    }
      setOpenModal(true);
    } else if (playerBoxClass === "loose") {

    if(isSound){
      const lose = new Audio(loseSound);
      lose.play();
    }

      if (betAmt >= walletAmt) {
        setWinningAmt(0);
        setLocalItem("depositAmt", 0);
        setWalletAmt(0);
        updateWinLoseCountAction("lose");
      } else {
        let updateWalletAmt = walletAmt - Number(betAmt);
        setWalletAmt(updateWalletAmt);
        setWinningAmt(updateWalletAmt);
        setLocalItem("depositAmt", updateWalletAmt);
        // liveWageredStatusAction("wagered", betAmt);
        updateWinLoseCountAction("lose");
      }
    }
  }, [gameStatus]);

  const dealerHandRef = useRef<HTMLDivElement>(null);
  const playerHandRef = useRef<HTMLDivElement>(null);
  const playerSplitHandRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (setDealerHandRef && dealerHandRef.current) {
      setDealerHandRef(dealerHandRef.current);
    }
    if (setPlayerHandRef && playerHandRef.current) {
      setPlayerHandRef(playerHandRef.current);
    }
    if (setPlayerSplitHandRef && playerSplitHandRef.current) {
      setPlayerSplitHandRef(playerSplitHandRef.current);
    }
  }, [setDealerHandRef, setPlayerHandRef, setPlayerSplitHandRef]);

  return (
      <div className="game-content">
      <div className="game-content-layout">
        <div className="game-content-container">
          <div className="dealer-container" id="dealer-box">
            <div className="game-point-box">
              {dealerTotal && (
                <div className="game-point">{delayedDealerTotal}</div>
              )}
            </div>
            <div
              className="dealer-card-container"
              ref={dealerHandRef}
              style={dealerContainerStyles}
            >
              <p id="empty1"></p>
              {dealerCards.map((card, index) =>
                renderCard(card, index, dealerCards.length)
              )}
            </div>
          </div>

          <div
            className={`player-container ${!isSplit ? playerBoxClass : ""} ${
              isSplit ? "isSplit" : ""
            }`}
            id="player-box"
          >
            <div
              className={`dealer-container ${
                handStatuses[0] === "lost" &&
                hasPlayerStand[0] === true &&
                gameStatus !== "playing"
                  ? "loose"
                  : handStatuses[0] === "won" &&
                    hasPlayerStand[0] === true &&
                    gameStatus !== "playing"
                  ? "winner"
                  : handStatuses[0] === "draw" &&
                    hasPlayerStand[0] === true &&
                    gameStatus !== "playing"
                  ? "draw"
                  : ""
              }`}
            >
              <div
                className={`dealer-card-container ${
                  isSplit && handIndex === 0 && gameStatus === "playing"
                    ? "active"
                    : ""
                }`}
                ref={playerHandRef}
                style={playerContainerStyles}
              >
                <div
                  style={{
                    opacity:
                      isSplit && handIndex === 0 && gameStatus === "playing"
                        ? 1
                        : 0,
                  }}
                  className="split-hand-indicator"
                >
                  <HandIndicator />
                </div>
                <p id="empty2"></p>
                {playerCards[0]?.map((card, index) =>
                  renderCard(card, index, playerCards[0].length)
                )}
              </div>
              <div
                className={`game-point-box ${
                  isSplit && handIndex === 0 && gameStatus === "playing"
                    ? "active"
                    : ""
                }`}
              >
                {playerTotal && (
                  <div className="game-point">{delayedPlayerTotal}</div>
                )}
              </div>
            </div>

            {isSplit && playerCards[1]?.length > 0 && (
              <div
                className={`dealer-container ${
                  handStatuses[1] === "lost" &&
                  hasPlayerStand[1] === true &&
                  gameStatus !== "playing"
                    ? "loose"
                    : handStatuses[1] === "won" &&
                      hasPlayerStand[1] === true &&
                      gameStatus !== "playing"
                    ? "winner"
                    : handStatuses[1] === "draw" &&
                      hasPlayerStand[1] === true &&
                      gameStatus !== "playing"
                    ? "draw"
                    : ""
                }`}
              >
                <div
                  className={`dealer-card-container ${
                    isSplit && handIndex === 1 && gameStatus === "playing"
                      ? "active"
                      : ""
                  }`}
                  ref={playerSplitHandRef}
                  style={playerSplitContainerStyles}
                >
                  <div
                    style={{
                      opacity:
                        isSplit && handIndex === 1 && gameStatus === "playing"
                          ? 1
                          : 0,
                    }}
                    className="split-hand-indicator"
                  >
                    <HandIndicator />
                  </div>
                  <p id="empty3"></p>
                  {playerCards[1]?.map((card, index) =>
                    renderCard(card, index, playerCards[1].length)
                  )}
                  <div
                    className={`game-point-box ${
                      isSplit && handIndex === 1 && gameStatus === "playing"
                        ? "active"
                        : ""
                    }`}
                  >
                    {playerTotal ? (
                      <div className="game-point">
                        {delayedPlayerSplitTotal}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

            <CustomModal
            open={openModal}
            setOpen={setOpenModal}
            autoClose={true}
            children={
              <div
                style={{
                  backgroundColor: "#24262f", // bg-light
                  borderRadius: "1rem", // rounded-xl
                  border: "4px solid rgba(228, 234, 240, 0.1)", // border-4 border-[#e4eaf019]
                  position: "absolute",
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  margin: "auto",
                  width: "216px",
                  height: "fit-content",
                  padding: "8px",
                }}
              >
                <div>
                  <img src={youWon} alt="" width="200px" />
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "8px",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <img src={star} />
                  </div>
                  <span
                    style={{
                      fontSize: "30px",
                      color: "#7717ff",
                      display: "block",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    1.92
                  </span>
                  <div style={{ transform: "rotateY(180deg)" }}>
                    <img src={star} />
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "8px",
                    alignItems: "center",
                    borderRadius: "8px",
                    backgroundColor: "#424B4D",
                    padding: "8px",
                    marginTop: "8px",
                    marginBottom: "8px",
                  }}
                >
                  <span
                    style={{
                      color: "#fff",
                      fontSize: "16px",
                    }}
                  >
                    ₹{winningAmt}
                  </span>
                  <img src={INR} alt="" width="24px" />
                </div>
              </div>
            }
          />
    </div>
  );
};

export default GameTable;
